/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, total: NonNullable<unknown> }} Cmspost_Page1Inputs */

const vi_cmspost_page1 = /** @type {(inputs: Cmspost_Page1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trang ${i?.page}/${i?.total}`)
};

/**

* @param {Cmspost_Page1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_page1 = /** @type {((inputs: Cmspost_Page1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Page1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_page1(inputs)
});
export { cmspost_page1 as "cmsPost_page" }